/* This class represents a lead of type More Information for a community. */
export default class CommunityInformationLead {
    constructor(formData) {
      this.communityId = formData.id;
      this.comments = formData.comments;
      this.includeRecommendations = formData.includeRecommended;
      this.mailAddress = formData.email;
      this.name = formData.name;
      this.type = 'postCommunityBrochure';
      this.userPhoneNumber = formData.phone;
      this.leadAction = formData.leadAction;
      this.fromPage = formData.fromPage;
      this.excludeRecommendations = formData.excludeRecommendations;
      this.realtorQuestionAnswerId = formData.realtorQuestion;
      this.preferredContactMethod = formData.preferredContactMethod;
      this.isAddMeToInterestList = formData.isAddMeToInterestList;
      this.guid = formData.guid;
  
      if (formData.postalCode) {
        this.userPostalCode = formData.postalCode;
      } else {
        this.livesOutside = true;
      }
    }

    setHousingInformation(properties) {
      this.marketId = properties.marketId;
      this.marketName = properties.marketName;
      this.builderName = properties.brandName;
      this.communityName = properties.communityName;
      this.wasMatchedAsSpotlightResult = properties.wasMatchedAsSpotlightResult;
      this.spotlightResultPosition =
        properties.wasMatchedAsSpotlightResult === 'true' ? Number(properties.index) + 1 : null;
    }
  }
  